export default __webpack_public_path__ + "static/media/queen_of_koi_both_versions.5c65011d.jpg";